import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { RouterModule } from '@angular/router';
import { ReactiveFormsModule, FormsModule } from '@angular/forms';
import { MaterialModule } from './material.module';
import { NavbarComponent } from './components/navbar/navbar.component';
import { SidebarComponent } from './components/sidebar/sidebar.component';
import { GenericTableComponent } from './components/generic-table/generic-table.component';
import { DateSelectComponent } from './components/date-select/date-select.component';
import { FormInputComponent } from './components/form-input/form-input.component';
import { FormSelectComponent } from './components/form-select/form-select.component';
import { MappingDialog } from './components/mapping-dialog/mapping-dialog';
import { PatientSearchDialogComponent } from './components/patient-search-dialog/patient-search-dialog.component';
import { BreadcrumbComponent } from './components/breadcrumb/breadcrumb.component';
import { UserProfileMenuComponent } from './components/user-profile-menu/user-profile-menu.component';

@NgModule({
  declarations: [
    NavbarComponent,
    SidebarComponent,
    GenericTableComponent,
    DateSelectComponent,
    FormInputComponent,
    FormSelectComponent,
    MappingDialog,
    PatientSearchDialogComponent,
    BreadcrumbComponent,
    UserProfileMenuComponent,
  ],
  imports: [
    CommonModule,
    RouterModule,
    MaterialModule,
    ReactiveFormsModule,
    FormsModule,
  ],
  exports: [
    MaterialModule,
    NavbarComponent,
    SidebarComponent,
    GenericTableComponent,
    DateSelectComponent,
    FormInputComponent,
    FormSelectComponent,
    PatientSearchDialogComponent,
    BreadcrumbComponent,
    UserProfileMenuComponent,
    ReactiveFormsModule,
    FormsModule,
  ],
})
export class SharedModule {}
